<template>
  <div class="advisory-step-1 padding-bottom-ml">
    <div class="content">
      <div class="padding-horizontal-ml">
        <advisory-top-header @close="close" @back="close" variant="blue"/>
        <Stepper :current-step="1" :total-steps="stepsNumber"/>
        <div class="ri-title margin-top-ml">
          ייעוץ אישי ברייזאפ
        </div>
        <div class="ri-small-display margin-top-ml ri-alte-bold">
          <span>אנחנו רוצים לבנות לך תכנית אישית </span>
          <span class="pink">שמותאמת לחיים ולמטרות שלך</span>
        </div>
        <img src="/images/advisory/tomer-story.svg" class="tomer-image margin-top-l"/>
      </div>
    </div>
    <div class="padding-horizontal-ml">
      <riseup-button :action="next"
                     :size="'slim'"
                     title="מעניין! מה זה כולל?"
                     :variant="'primary'"/>
    </div>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import { mapGetters } from 'vuex';
import Segment from '@/Segment';
import AdvisoryTopHeader from './AdvisoryTopHeader';

export default {
  name: 'AdvisoryIntro1',
  components: {
    AdvisoryTopHeader,
    RiseupButton: BaseUI.RiseupButton,
    Stepper: BaseUI.Stepper,
  },
  created() {
    Segment.trackUserGot('AdvisoryIntro1');
  },
  methods: {
    next() {
      this.$emit('next');
    },
    close() {
      this.$emit('close');
    },
  },
  computed: {
    ...mapGetters('advisory', ['stepsNumber']),
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.advisory-step-1 {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #142AA0;

  .content {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    text-align: start;
    color: $riseup_white;

    .pink {
      color: #F89BB4;
    }

    .tomer-image {
      width: 100%;
    }
  }
}
</style>
